import { ParameterType } from '@/study-search/enums';

import { Filter } from './Filter';
import { FilterKey } from '@studyportals/search-filters/server-side';

export abstract class SingleValueFilter extends Filter {
	protected constructor(
		public readonly key: FilterKey,
		public readonly type: ParameterType,
		public values: string[],
		public collapsed: boolean = true,
		public readonly structured: boolean = true,
	) {
		super(key, type, values, collapsed);
	}

	public processValue(value: string): void {
		const valueIsIncluded = this.values.includes(value);
		this.values.splice(0, this.values.length);

		if (!valueIsIncluded) {
			this.values.push(value);
		}
	}
}
